import React from 'react';
import InvoiceForm from '../components/InvoiceGenerator/InvoiceForm';
import AdBanner from '../components/Layout/AdBanner';

const GenerateInvoice: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="pt-4 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
              Generate Professional Invoice
            </h1>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Create beautiful, professional invoices in minutes. Fill out the form below and download your invoice as a PDF instantly.
            </p>
          </div>

          {/* Ad Banner */}
          <div className="mb-4">
            <AdBanner size="responsive" className="mx-auto" />
          </div>

          <InvoiceForm />

          {/* Bottom Ad */}
          <div className="mt-6">
            <AdBanner size="responsive" className="mx-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateInvoice;